import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { isAxiosError, isCancel } from "axios";

import FullPageLoader from "../component/common/FullPageLoader";
import { useAppNavigate } from "./useAppNavigate";
import { useLoginUser } from "../hooks/useLoginUser";
import { handleError } from "../utils/error/handleError";
import { useGlobalSignout } from "../hooks/useGlobalSignout";

const AuthGuard = () => {
  const { publicNavigate } = useAppNavigate();
  const { signOut: globalSignout } = useGlobalSignout();
  const { user, isFetching, isError, error } = useLoginUser();

  useEffect(() => {
    const signOut = async () => {
      await globalSignout();
      publicNavigate.login();
    };

    if (isError) {
      handleError(error);
      if (
        isCancel(error) ||
        (isAxiosError(error) && error.response?.status === 401)
      ) {
        signOut();
        return;
      }

      throw error;
    }
  }, [isError, error, globalSignout, publicNavigate]);

  if (!user || isFetching) return <FullPageLoader />;

  return <Outlet />;
};

export default AuthGuard;
